import PropTypes from 'prop-types';

export const nullStatePropTypes = {
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
};
